module.exports = __webpack_public_path__ + "img/9788925562131.17770de4.jpg";